
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 72 73","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 36.934C0 17.088 16.088 1 35.934 1c19.845 0 35.934 16.088 35.934 35.934 0 19.846-16.09 35.934-35.934 35.934C16.088 72.868 0 56.78 0 36.934","fill":"#E9FCD9"}}),_c('path',{attrs:{"d":"M52.204 18.617c1.421.757 2.359 1.946 2.812 3.557.448 1.614.27 3.13-.538 4.556L39.676 53.425c-.951 1.707-2.399 2.703-4.345 2.989l-.854.073c-1.614 0-3.012-.595-4.198-1.78l-11.89-11.818c-1.186-1.185-1.777-2.587-1.777-4.198 0-1.614.591-3.016 1.777-4.202 1.185-1.185 2.587-1.78 4.202-1.78 1.61 0 3.011.595 4.197 1.78l6.338 6.265 10.96-19.79c.761-1.424 1.946-2.37 3.56-2.845 1.615-.476 3.133-.31 4.558.498","fill":"#98D385"}})])])
          )
        }
      }
    